module.exports = __webpack_public_path__ + "static/media/liquidity-provider.d3ac6903.png";